export default __webpack_public_path__ + "static/media/RILAC-Logo1.b9837439.svg";